export default function ({ app, store, redirect }) {
  if (
    !store.state.customer.customerAccessToken ||
    !store.state.customer.customerAccessToken.accessToken
  ) {
    return redirect(app.localePath(`/signin`))
  }
}
